import { apiClient } from '@/shared/api/client'

export const getComments = async (leadId) => {
  const response = await apiClient.get(`/comments/${leadId}`)
  return response.data.data
}

export const getPurchaseOrderComments = async (purchaseOrderId) => {
  const response = await apiClient.get(
    `/comments/purchase-order/${purchaseOrderId}`,
  )
  return response.data.data
}

export const createComment = async (payload) => {
  const response = await apiClient.post('/comments', payload)
  return response.data.data
}

export const getCommentNotifications = async () => {
  const response = await apiClient.get('/comments/notifications')
  return response.data.data
}

export const getCommentNotificationUnreadCount = async () => {
  const response = await apiClient.get('/comments/notifications/unread-count')
  return response.data.data
}

export const markCommentNotificationsAsRead = async (notificationIds) => {
  const response = await apiClient.patch('/comments/notifications/read', {
    notificationIds,
  })

  return response.data.data
}

// export const updateComment = async (commentId, payload) => {
//   const response = await apiClient.put(
//     `/comments/${commentId}`,
//     payload,
//   )
//   return response.data.data
// }

// export const deleteComment = async (commentId) => {
//   await apiClient.delete(`/comments/${commentId}`)
// }
